export * from "./show.component";
